module.exports = __webpack_public_path__ + "media/Ball.e2925f31.mp3";